const Menu = [
    {
        id: 1,
        category:"Workshop",
        image:"img/events/Workshop_1.png",
        title:"Acting Workshop",
        date:"Starting Sept 2025",
        quality:"NEW",
        duration:"2 Hours",
       
    },
    {
        id: 2,
        category:"Movies",
        image:"img/events/casting_1.png",
        title:"Audition Call",
        date:"Feb 9, 2025",
        quality:"PAST",
        duration:"9 AM - 3 PM",
       
    },    
    {
        id: 3,
        category:"Movies",
        image:"img/events/casting_1.png",
        title:"Audition Call",
        date:"Feb 16, 2025",
        quality:"PAST",
        duration:"9 AM - 3 PM",
       
    },
    
    
    
    
] 
export default Menu;